import React, {useEffect, useState} from 'react';
import styles from "./ConfirmClientPopUp.module.css";
import Modal from "react-modal";
import {confirmClientAPI} from "../../../services/admin";
import {ConfirmClientRequest} from "../../../types/admin";
import {ClientStatus} from "../../../types/contract";

interface ConfirmClientPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    clientId: number | undefined;
}

//클라이언트 계정 처리 팝업
const ConfirmClientPopUp: React.FC<ConfirmClientPopUpProps> = ({
                                                                   isOpen,
                                                                   onClose,
                                                                   clientId
                                                               }) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [formData, setFormData] = useState<ConfirmClientRequest>({
        clientId: 0,
        clientStatus: ClientStatus.승인,
        comment: '',
        email: true
    });

    useEffect(() => {
        if (clientId) {
            setFormData({
                clientId: clientId,
                clientStatus: ClientStatus.승인,
                comment: '',
                email: true
            });
        }
    }, [clientId]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!clientId) return;
        setIsSubmitting(true);

        try {
            //클라이언트 계정 처리 API
            await confirmClientAPI(formData);
            //처리 후 팝업 닫기
            onClose();
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const showCommentField = formData.clientStatus === ClientStatus.반려;
    //반려 시 반려 사유 필수
    const isSubmitDisabled = !clientId ||
        isSubmitting ||
        (showCommentField && !formData.comment.trim());

    const handleStatusChange = (status: ClientStatus) => {
        setFormData(prev => ({
            ...prev,
            clientStatus: status,
            //승인 시 반려 사유 빈 값
            comment: status === ClientStatus.승인 ? '' : prev.comment
        }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>클라이언트 계정 상태 처리</h2>
                    {/*닫기 버튼*/}
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                        aria-label="Close"
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        <div className={styles.email}>
                            <label>처리</label>
                            {/*처리 결과 메일 전달 여부 선택*/}
                            <span>
                                E-Mail로 결과 전달
                                <input
                                    type="checkbox"
                                    checked={formData.email}
                                    onChange={(e) => setFormData(
                                        prev => ({
                                            ...prev,
                                            email: e.target.checked
                                        }))}
                                />
                            </span>
                        </div>
                        {/*처리 상태 선택, 승인/반려*/}
                        <select
                            value={formData.clientStatus}
                            onChange={(e) => handleStatusChange(e.target.value as ClientStatus)}
                            className={styles.select}
                            required
                            disabled={isSubmitting}
                        >
                            <option value={ClientStatus.승인}>{ClientStatus.승인}</option>
                            <option value={ClientStatus.반려}>{ClientStatus.반려}</option>
                        </select>
                    </div>

                    {showCommentField && (
                        <div className={styles.formGroup}>
                            {/*반려 시 반려 사유 기입*/}
                            <label>사유</label>
                            <textarea
                                value={formData.comment}
                                onChange={(e) => setFormData(prev => ({
                                    ...prev,
                                    comment: e.target.value
                                }))}
                                className={styles.textarea}
                                placeholder={`${formData.clientStatus} 사유를 입력해주세요`}
                                rows={8}
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                    )}

                    {/*처리 버튼*/}
                    <button
                        type="submit"
                        className={styles.submitButton}
                        disabled={isSubmitDisabled}
                    >
                        {isSubmitting ? '처리 중...' : '처리'}
                    </button>
                </form>
            </div>
        </Modal>
    );
}

export default ConfirmClientPopUp;